import React, { Component } from "react";
import { View, Text, TextInput, Button, Platform } from "react-native";
import styles from "../OtpScreen/styles";
import textConstants from "../../constants/textConstants";
import HocComponent from "../../commonComponents/Hoc";
const regexOnlyNumber = /^[0-9]+$/;
class OtpScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      t1: "",
      t2: "",
      t3: "",
      t4: "",
      t5: "",
      t6: "",
    };
    this.a = React.createRef();
    this.b = React.createRef();
    this.c = React.createRef();
    this.d = React.createRef();
    this.e = React.createRef();
    this.f = React.createRef();
    this.valArray = {};
  }

  handleKeyPress({ nativeEvent: { key: keyValue } }, field) {
    if (keyValue === "Backspace") {
      const { otpValue } = this.props;

      this.valArray = { ...this.valArray, [field]: "" };
      otpValue(this.valArray);
    }
  }

  getRegex = (text, regex, prevValue) => {
    let isChecked;
    if (
      text === "" ||
      text === null ||
      text === undefined ||
      text === "undefined"
    ) {
      // JUST BLANK
      text = Platform.OS === "web" ? "" : text;
    } else if (!text.match(regex)) {
      isChecked = true;
    }
    return isChecked ? prevValue : text;
  };

  onchangeValue = (e, field) => {
    const { t1, t2, t3, t4, t5, t6, t7, t8, t9, t10, t11, t12 } = this.state;
    const { otpValue } = this.props;
    let value = "";
    if (field === "t1") {
      value = t1;
    } else if (field === "t2") {
      value = t2;
    } else if (field === "t3") {
      value = t3;
    } else if (field === "t4") {
      value = t4;
    } else if (field === "t5") {
      value = t5;
    } else if (field === "t6") {
      value = t6;
    }

    const filteredText = this.getRegex(e, regexOnlyNumber, value);
    console.log("regexOnlyNumber1", e);
    console.log("regexOnlyNumber2", filteredText);
    if (field === "t1") {
      if (filteredText !== "") {
        this.b.current.focus();
      }
    } else if (field === "t2") {
      if (filteredText !== "") {
        this.c.current.focus();
      } else {
      }
    } else if (field === "t3") {
      if (filteredText !== "") {
        this.d.current.focus();
      } else {
      }
    } else if (field === "t4") {
      if (filteredText !== "") {
        this.e.current.focus();
      } else {
      }
    } else if (field === "t5") {
      if (filteredText !== "") {
        this.f.current.focus();
      } else {
      }
    } else if (field === "t6") {
      if (filteredText !== "") {
        this.f.current.focus();
      }
    }

    this.setState({
      [field]: filteredText,
    });

    this.valArray = { ...this.valArray, [field]: filteredText };

    otpValue(this.valArray);
  };

  
  render() {
    const { t1, t2, t3, t4, t5, t6, t7, t8, t9, t10, t11, t12 } = this.state;
    let resOtpBox = `otpStyle_${this.props.measure}`;
    return (
      <View>
        <View style={styles.otpContainerStyle1}>
          <TextInput
            keyboardType="numeric"
            returnKeyType="done"
            ref={this.a}
            autoFocus
            value={t1}
            maxLength={1}
            onFocus={() => {
              const { otpValue } = this.props;
              this.valArray = {
                ...this.valArray,
                t1: t1,
              };
              otpValue(this.valArray);
            }}
            style={Platform.OS == 'web' ? [styles.otpStyle, styles[resOtpBox], { outline: "none" }] :
              [styles.otpStyle, styles[resOtpBox]]
            }
            onKeyPress={(e) => this.handleKeyPress(e, "t1")}
            onChangeText={(e) => this.onchangeValue(e, "t1")}
          />
          <TextInput
            keyboardType="numeric"
            returnKeyType="done"
            ref={this.b}
            value={t2}
            maxLength={1}
            onFocus={() => {
              const { otpValue } = this.props;
              this.valArray = {
                ...this.valArray,
                t2: t2,
              };
              otpValue(this.valArray);
            }}
            style={Platform.OS == 'web' ? [styles.otpStyle, styles[resOtpBox], { outline: "none" }] :
              [styles.otpStyle, styles[resOtpBox]]
            }
            onKeyPress={(e) => this.handleKeyPress(e, "t2")}
            onChangeText={(e) => this.onchangeValue(e, "t2")}
          />
          <TextInput
            keyboardType="numeric"
            returnKeyType="done"
            ref={this.c}
            value={t3}
            onFocus={() => {
              const { otpValue } = this.props;
              this.valArray = {
                ...this.valArray,
                t3: t3,
              };
              otpValue(this.valArray);
            }}
            maxLength={1}
            style={Platform.OS == 'web' ? [styles.otpStyle, styles[resOtpBox], { outline: "none" }] :
              [styles.otpStyle, styles[resOtpBox]]
            }
            onKeyPress={(e) => this.handleKeyPress(e, "t3")}
            onChangeText={(e) => this.onchangeValue(e, "t3")}
          />
          <TextInput
            keyboardType="numeric"
            returnKeyType="done"
            ref={this.d}
            value={t4}
            maxLength={1}
            onFocus={() => {
              const { otpValue } = this.props;
              this.valArray = {
                ...this.valArray,
                t4: t4,
              };
              otpValue(this.valArray);
            }}
            style={Platform.OS == 'web' ? [styles.otpStyle, styles[resOtpBox], { outline: "none" }] :
              [styles.otpStyle, styles[resOtpBox]]
            }
            onKeyPress={(e) => this.handleKeyPress(e, "t4")}
            onChangeText={(e) => this.onchangeValue(e, "t4")}
          />
          <TextInput
            keyboardType="numeric"
            returnKeyType="done"
            ref={this.e}
            value={t5}
            maxLength={1}
            onFocus={() => {
              const { otpValue } = this.props;
              this.valArray = {
                ...this.valArray,
                t5: t5,
              };
              otpValue(this.valArray);
            }}
            style={Platform.OS == 'web' ? [styles.otpStyle, styles[resOtpBox], { outline: "none" }] :
              [styles.otpStyle, styles[resOtpBox]]
            }
            onKeyPress={(e) => this.handleKeyPress(e, "t5")}
            onChangeText={(e) => this.onchangeValue(e, "t5")}
          />
          <TextInput
            keyboardType="numeric"
            returnKeyType="done"
            ref={this.f}
            value={t6}
            onFocus={() => {
              const { otpValue } = this.props;
              this.valArray = { ...this.valArray, t6: t6 };
              otpValue(this.valArray);
            }}
            maxLength={1}
            style={Platform.OS == 'web' ? [styles.otpStyle, styles[resOtpBox], { outline: "none" }] :
              [styles.otpStyle, styles[resOtpBox]]
            }
            onKeyPress={(e) => this.handleKeyPress(e, "t6")}
            onChangeText={(e) => this.onchangeValue(e, "t6")}
          />
        </View>
      </View>
    );
  }
}

export default HocComponent(OtpScreen);
